module.exports = __webpack_public_path__ + "static/media/wall-roof.b514616f.png";